import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useScreen } from '../lib/useScreen';
import { useTracker } from '../lib/useTracker';
import { useAuth } from '../lib/AuthProvider';
import { startCheckout } from '../lib/checkout';
import { supabase } from '../lib/supabaseClient';

const C = {
  turquesa: '#5dc1b9',
  mango: '#FDBE02',
  coral: '#eb636b',
  logoGrad: 'linear-gradient(135deg, #534AB7, #1D9E75)',
};
const font = "'DM Sans', sans-serif";
const serif = "'DM Serif Display', serif";

const glassCard = {
  background: 'rgba(255,255,255,0.05)',
  backdropFilter: 'blur(30px)',
  WebkitBackdropFilter: 'blur(30px)',
  border: '1px solid rgba(255,255,255,0.1)',
  borderRadius: 20,
};

export default function Membresias() {
  const navigate = useNavigate();
  const { isMobile, isTablet } = useScreen();
  const { user, profile } = useAuth();
  useTracker("membresias", null);

  const handleBuy = (key) => {
    if (key === 'free_observer') {
      if (!user) {
        supabase.auth.signInWithOAuth({ provider: 'google', options: { redirectTo: window.location.origin + '/dashboard' } });
      } else {
        navigate('/sala');
      }
      return;
    }
    if (!user) {
      localStorage.setItem('td_pending_checkout', key);
      supabase.auth.signInWithOAuth({ provider: 'google', options: { redirectTo: window.location.origin + '/dashboard' } });
      return;
    }
    startCheckout(key, user, profile);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0a0a0a', color: '#fff', fontFamily: font }}>
      {/* NAV */}
      <nav style={{ maxWidth: 1100, margin: '0 auto', padding: isMobile ? '1rem' : '1.2rem 1.5rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div onClick={() => navigate('/')} style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }}>
          <div style={{ width: 38, height: 38, borderRadius: '50%', background: C.logoGrad, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span style={{ color: '#fff', fontSize: 12, fontWeight: 500 }}>T&D</span>
          </div>
          <span style={{ fontSize: 16, fontWeight: 500 }}>Thinker & Doer</span>
        </div>
        <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
          <span onClick={() => navigate('/')} style={{ fontSize: 14, color: 'rgba(255,255,255,0.6)', cursor: 'pointer' }}>Inicio</span>
          <span onClick={() => navigate('/nosotros')} style={{ fontSize: 14, color: 'rgba(255,255,255,0.6)', cursor: 'pointer' }}>Nosotros</span>
        </div>
      </nav>

      {/* HEADER */}
      <section style={{ maxWidth: 1100, margin: '0 auto', padding: isMobile ? '3rem 1rem 2rem' : '5rem 1.5rem 3rem', textAlign: 'center' }}>
        <p style={{ fontSize: isMobile ? 11 : 13, color: C.turquesa, fontWeight: 500, letterSpacing: 2, margin: '0 0 14px' }}>MEMBRESIAS</p>
        <h1 style={{ fontFamily: serif, fontSize: isMobile ? 24 : 36, fontWeight: 400, margin: '0 0 12px', color: '#fff' }}>Elige tu plan</h1>
        <p style={{ fontSize: isMobile ? 13 : 15, color: 'rgba(255,255,255,0.5)', margin: '0 0 8px' }}>Empieza gratis. Un solo plan premium. Sin complicaciones.</p>
      </section>

      {/* PLAN CARDS */}
      <section style={{ maxWidth: 1100, margin: '0 auto', padding: isMobile ? '0 1rem 2rem' : '0 1.5rem 3rem' }}>
        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? '1fr' : isTablet ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)', gap: 16 }}>

          {/* Free Observer */}
          <div style={{ ...glassCard, padding: '28px 24px', display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
            <p style={{ fontSize: 11, letterSpacing: 2, fontWeight: 700, color: 'rgba(255,255,255,0.4)', margin: '0 0 8px' }}>GRATIS PARA SIEMPRE</p>
            <p style={{ fontFamily: serif, fontSize: 22, fontWeight: 400, color: '#fff', margin: '0 0 4px' }}>Free Observer</p>
            <p style={{ fontSize: 28, fontWeight: 600, color: '#fff', margin: '0 0 16px' }}>$0</p>
            <ul style={{ margin: '0 0 20px', padding: 0, listStyle: 'none', textAlign: 'left', color: 'rgba(255,255,255,0.6)', fontSize: 13, lineHeight: 2 }}>
              {[
                'Arbol completo: ve y llena todas las misiones',
                'Vence Raiz + Mundo 01',
                'Tu carta de negocio publica',
                'Ver las cartas de la comunidad',
                'Bitacora privada (15 notas)',
                'Genio y Luca con cupo semanal',
              ].map((f, i) => (
                <li key={i}><span style={{ color: C.turquesa, fontWeight: 700, marginRight: 6 }}>&#10003;</span>{f}</li>
              ))}
            </ul>
            <div style={{ flex: 1 }} />
            <button onClick={() => handleBuy('free_observer')} style={{
              background: 'transparent', color: 'rgba(255,255,255,0.7)', border: '1px solid rgba(255,255,255,0.2)',
              borderRadius: 50, padding: '12px 24px', fontSize: 14, fontWeight: 500, cursor: 'pointer', fontFamily: font, width: '100%',
            }}>
              Empezar gratis
            </button>
          </div>

          {/* Doer — highlighted */}
          <div style={{ ...glassCard, padding: '28px 24px', display: 'flex', flexDirection: 'column', textAlign: 'center', border: `1px solid ${C.turquesa}`, boxShadow: '0 0 50px rgba(93,193,185,0.12)', position: 'relative' }}>
            <span style={{ position: 'absolute', top: -12, left: '50%', transform: 'translateX(-50%)', background: C.turquesa, color: '#fff', fontSize: 10, fontWeight: 700, letterSpacing: 1, padding: '4px 14px', borderRadius: 20 }}>RECOMENDADO</span>
            <p style={{ fontSize: 11, letterSpacing: 2, fontWeight: 700, color: C.turquesa, margin: '8px 0 8px' }}>PREMIUM</p>
            <p style={{ fontFamily: serif, fontSize: 22, fontWeight: 400, color: '#fff', margin: '0 0 4px' }}>Doer</p>
            <p style={{ fontSize: 28, fontWeight: 600, color: '#fff', margin: '0 0 2px' }}>$139 <span style={{ fontSize: 14, color: 'rgba(255,255,255,0.4)', fontWeight: 400 }}>MXN / mes</span></p>
            <p style={{ fontSize: 11, color: C.mango, fontWeight: 600, margin: '0 0 16px' }}>7 dias gratis al vencer Mundo 01</p>
            <ul style={{ margin: '0 0 20px', padding: 0, listStyle: 'none', textAlign: 'left', color: 'rgba(255,255,255,0.6)', fontSize: 13, lineHeight: 2 }}>
              {[
                'Todo lo gratis',
                'Vence todos los jefes: del Mundo 02 a Madurez',
                'Luca revisa tu evidencia y audita tu expediente',
                'OKR trimestral y reportes de avance',
                'Comparte tus aprendizajes y haz match',
                'Genio y Luca sin limite, con contexto de tu arbol',
                'Bitacora ilimitada conectada a Mis Ideas',
                'Elegible para el crowdfunding',
              ].map((f, i) => (
                <li key={i}><span style={{ color: C.turquesa, fontWeight: 700, marginRight: 6 }}>&#10003;</span>{f}</li>
              ))}
            </ul>
            <div style={{ flex: 1 }} />
            <button onClick={() => handleBuy('doer')} style={{
              background: 'linear-gradient(135deg, #534AB7, #1D9E75)', color: '#fff', border: 'none',
              borderRadius: 50, padding: '14px 24px', fontSize: 15, fontWeight: 600, cursor: 'pointer', fontFamily: font, width: '100%',
              boxShadow: '0 0 30px rgba(93,193,185,0.3)',
            }}>
              Probar 7 dias gratis
            </button>
          </div>

          {/* Tu Radar */}
          <div style={{ ...glassCard, padding: '28px 24px', display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
            <p style={{ fontSize: 11, letterSpacing: 2, fontWeight: 700, color: C.coral, margin: '0 0 8px' }}>PAGO UNICO</p>
            <p style={{ fontFamily: serif, fontSize: 22, fontWeight: 400, color: '#fff', margin: '0 0 4px' }}>Tu Radar</p>
            <p style={{ fontSize: 28, fontWeight: 600, color: '#fff', margin: '0 0 2px' }}>$599 <span style={{ fontSize: 14, color: 'rgba(255,255,255,0.4)', fontWeight: 400 }}>MXN</span></p>
            <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)', margin: '0 0 16px' }}>Acceso de por vida</p>
            <ul style={{ margin: '0 0 20px', padding: 0, listStyle: 'none', textAlign: 'left', color: 'rgba(255,255,255,0.6)', fontSize: 13, lineHeight: 2 }}>
              {[
                'No sabes que emprender? Esto es para ti',
                'Test de personalidad + radar de habilidades',
                '31 formas reales de generar ingresos',
                '5 videos exclusivos de Bruno',
                'Genio y Luca te acompanan 30 dias',
                'Decides tu camino con datos, no con intuicion',
              ].map((f, i) => (
                <li key={i}><span style={{ color: C.coral, fontWeight: 700, marginRight: 6 }}>&#10003;</span>{f}</li>
              ))}
            </ul>
            <div style={{ flex: 1 }} />
            <button onClick={() => handleBuy('tu_radar')} style={{
              background: C.coral, color: '#fff', border: 'none',
              borderRadius: 50, padding: '12px 24px', fontSize: 14, fontWeight: 500, cursor: 'pointer', fontFamily: font, width: '100%',
            }}>
              Quiero mi Radar
            </button>
          </div>

        </div>
        <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', textAlign: 'center', margin: '20px 0 0' }}>
          Al comprar aceptas nuestros <a href="/terminos" style={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'underline' }}>Terminos</a> y <a href="/privacidad" style={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'underline' }}>Aviso de privacidad</a>.
        </p>
      </section>

      {/* FOOTER */}
      <footer style={{ maxWidth: 1100, margin: '0 auto', padding: '2rem 1.5rem', textAlign: 'center', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
        <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.3)', margin: '0 0 10px' }}>© 2026 Thinker & Doer</p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 16 }}>
          <a href="/terminos" style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', textDecoration: 'none' }}>Terminos</a>
          <a href="/privacidad" style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)', textDecoration: 'none' }}>Privacidad</a>
        </div>
      </footer>
    </div>
  );
}
